import { Modal, Row, Col } from "react-bootstrap";
import ButtonCommon from "./ButtonCommon";
import "./ModalCommon.css";
import { FormattedMessage } from "react-intl";

const ModalCommon = (props: any) => {
  const onHandleClose = () => {
    if (props.OnModalClose) props.OnModalClose();
  };

  const onHandleOk = () => {
    if (props.OnModalOk) props.OnModalOk();
  };

  return (
    <>
      <Modal
        show={props.Show}
        onHide={() => onHandleClose()}
        centered
        dialogClassName="my-modal"
        contentClassName="modal-height"
      >
        <Modal.Header closeButton style={{ borderBottom: "0" }}>
          <Modal.Title
            className={`font-modal-header ${props.HiddenTitle ? "d-none" : ""}`}
          >
            <FormattedMessage id={props.Title} defaultMessage="Titulo Modal" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-center">
            <Col xs={11}>{props.Content || "Modal Content"}</Col>
          </Row>
          <Row
            className={`justify-content-end mt-3 ${
              props.HiddenActions ? "d-none" : ""
            }`}
          >
            <Col xs={4} className="modal-common-button-cancel">
              <ButtonCommon
                label={
                  <FormattedMessage
                    id="ready-size-Cancelar"
                    defaultMessage="Cancelar"
                  />
                }
                isOutline={true}
                eventClick={() => onHandleClose()}
              />
            </Col>
            <Col xs={4} className="modal-common-button-associate">
              <ButtonCommon
                label={
                  <FormattedMessage
                    id={props.buttonSuccessTitle}
                    defaultMessage="Ok"
                  />
                }
                isOutline={false}
                eventClick={() => onHandleOk()}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCommon;
